import React from 'react';
import { Stack, Typography } from '@mui/material';

type Props = {
  prefix?: string;
  label: string;
  countryCode?: string;
};

const CountryOptionLabel = ({ prefix, label, countryCode }: Props) => (
  <Stack direction='row' alignItems='center'>
    {prefix && <Typography minWidth={35}>({prefix})</Typography>}
    {countryCode && (
      <img
        src={`https://flagcdn.com/w20/${String(countryCode).toLowerCase()}.png`}
        alt={countryCode}
        style={{ width: '20px', height: '15px', marginLeft: '5px' }}
      />
    )}
    <Typography ml={1}>{label}</Typography>
  </Stack>
);

export default CountryOptionLabel;
